import i18next from 'i18next';

i18next.addResources('en', 'RecordsTable', {
  period: 'Period',
  mashID: 'Mash ID',
  mashDate: 'Mash date',
  blockchain: 'Blockchain'
});
